import { Component, OnInit, Output, ElementRef, EventEmitter, Renderer, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { steppedFlyX, flyIn, overlay, expandablepoint } from '../item/item.animations';
import { flyInOut, fadeIn, fade, featureslist, animateOpen, rotateOpen, zFade, Cart, ShareMenu, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, featuresBox } from '../animations';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environment';
import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';
import { Currency } from '../../models/currency';
import { Statistic } from '../../models/statistics';
import { Category } from '../../models/category';
import { Product } from '../../models/product';
import { Item } from '../../models/item';

declare var $: any;
declare var MasterSlider: any

@Component({
  selector: 'product',
  templateUrl: './product.component.html',
  providers: [ StoreService, UserService ],
  animations: [ steppedFlyX, flyIn, overlay, flyInOut, fadeIn, expandablepoint, featuresBox, featureslist, animateOpen, rotateOpen, fade, zFade, Cart, ShareMenu, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop ]
})

export class ProductComponent implements OnInit {
	
	@ViewChild('shareLink') shareLink:ElementRef;
	@Output() addedtocart:EventEmitter<string> = new EventEmitter();

	loading = true;
	image = new Image();
	currency: Currency;
	currencies: Currency;
	products: Product;
	features: Product;
	selectedProduct: Product;
	purchased: Product;
	cartItems: Product;
	accountProducts: Product;
	accountItems: Item;
	socialStatistics: Statistic;
	custom: any;
	
	categories: Category;
	cart: any[];
	viewProduct: any;
	pointOpen: any;

	x = 0;
	showImage = 0;
	shareMenuOpen = false;
	showDetails = false;
	showFeatures = false;
	hideFeatured = false;
	flashCart = false;
	currencyOpen = false;
	purchaseButton = true;
	zoomable = true;
	enableCurrencySelector = false;

	stockNotice = true;
	betaNotice = false;
	requirementsNotice = false;
	limitedTime = true;

	itemBoxLeft = 0;
	itemImages = 0;
	LightboxImage = "";
	ShowLightbox: any;
	ShowPointbox: boolean;
	
	total: number;
	itemtotal: number;
	windowLink: string;
	title: string;
	header: any;
	featureCount: number;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	subtitleLink: string;
	subtitleIcon: string;
	totalImages: any;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router) {
		this.image.crossOrigin = 'anonymous';
		this.itemBoxLeft = 0;
	}


	/* 
	* Cart System
	*/

	inCart( listing ) {
		return ( this.cart.indexOf( listing ) > -1 ) ? true : false;
	}

	addToCart(product, i) {

		if ( product.limit == 0 || product.limit > product.owns ) {

			if ( this.inCart(product.id) ) {

				this.router.navigate(['/checkout']);

			} else if (product.instock && !this.inCart(product.id) ) {
				this.storeService.addToCart(product.id);
				this.updateCartButton();
				this.cart = this.storeService.getCartContents();
				this.getCart();
			}
		}
	}

	removeFromCart(productIndex) {
		this.storeService.removeFromCart(productIndex);
		this.getCart();
	}

	updateCartButton() {
	 	this.flashCart = true;
	 	setTimeout( () => { this.flashCart = false;  }, 5000);
	}

	openPoint(i) {
		this.ShowPointbox = true;
		this.pointOpen = i;
		console.log(this.ShowPointbox)
	}

	closePoint() {
		this.ShowPointbox = false;
		setTimeout( () => { this.pointOpen = 0; }, 50);
		console.log(this.ShowPointbox)
	}

	getProduct() {
		Promise.resolve(this.storeService.get(this.viewProduct)).then((productData) => {
			this.products = productData;

			if( this.products[0] && this.products[0].published ) {
				this.showImage = 0;

				this.betaNotice = ( this.products[0].beta == '1' ) ? true : false;
				if( this.products[0].title ) this.title = this.products[0].title;
				if( this.products[0].description ) this.subtitle = this.products[0].description;
				if( this.products[0].images[this.showImage] ) this.image.src = this.products[0].images[this.showImage].url;	

				setTimeout( () => { this.loading = false; }, 100);

				Promise.resolve( this.storeService.countProductImages(this.viewProduct) ).then( (imgs) => { 
					this.totalImages = imgs 
				});

			} else {
				window.location.pathname = '/products';
			}

		});
	}

	swipeImage(action = 'swipeleft', imageslength) {
        if (action === 'swipeleft') {
        	this.showImage = (this.showImage < imageslength-1) ? this.showImage+1 : this.showImage;
        	this.image.src = environment.baseUrl+'/assets'+this.products[0].images[this.showImage].url;
        }
        if (action === 'swiperight') {
        	this.showImage = (this.showImage > 0) ? this.showImage-1  : this.showImage;
        	this.image.src = environment.baseUrl+'/assets'+this.products[0].images[this.showImage].url;
        }
    }


	addQuantity(product) {
		this.storeService.addQuantity(product.id);
		this.getCart();
	}


	focusLink() {
		this.shareLink.nativeElement.focus();
	}

	subtractQuantity(product) {
		product.quantity--;
		if ( product.quantity == 1 )
			this.showDetails = false
		this.storeService.subtractQuantity(product.id);
		this.getCart();
	}

	getCart() {
		this.addedtocart.emit('complete');
		this.cart = this.storeService.getCartContents();
		Promise.resolve( this.storeService.getProducts(this.cart) ).then((cartdata) => {
			this.cartItems = cartdata
		});

		this.getTotal();
	}

	getTotal() {
		Promise.resolve(this.storeService.getCartTotal()).then(cartTotal => 
			this.total = cartTotal
		);
	}

	inAccount() {
		// Get the users products
		Promise.resolve( this.storeService.getPurchasedItems() ).then( (i) => {
			this.accountItems = i;
		}).catch(function (err) { });
	}

	/**
	* Currency Handling
	**/
	getCurrencies() {
		if ( environment.currencies ) {

			Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
				this.currencies = c;
			});

			Promise.resolve( this.storeService.getCurrency() ).then((c) => {
				this.currency = c[0];
			});

			Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
				this.enableCurrencySelector = bool;
			});
		}
	}
	


	changeCurrency(currency) {
		this.currency = currency;
		this.storeService.changeCurrency(currency);
	}



	ngOnInit() 
	{

		this.title = 'IDENTITY STORE';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/concept/club2.jpeg") 0px 47%' );
		this.subtitle = 'Get your passport and express yourself.';
		this.cart = this.storeService.getCartContents();
		this.headerHeight = '300px';

		this.windowLink =  window.location.href;
		this.viewProduct = this.route.snapshot.params['id'];

		this.router.events
		.filter(event => event instanceof NavigationEnd)
		.map(() => this.router.routerState.root)
		.subscribe((event) => {
			this.itemBoxLeft = 0;
			this.viewProduct = this.route.snapshot.params['id'];
			this.getProduct();
		});

		this.getProduct();
		this.inAccount();

		Promise.resolve(this.storeService.loadProducts()).then( (featuredProducts) => {
			this.features = featuredProducts;
			this.storeService.countProducts().subscribe( (count) => {
				this.featureCount = count;
			});
		});

		Promise.resolve(this.storeService.getCustomizerContents()).then((c) => {
			this.custom = c;
		});

		Promise.resolve(this.storeService.getCategories()).then( (categories) => {
			this.categories = categories
		});

		this.getCurrencies();
	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/product/product.component.ts